import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=6ce3c212&"
import script from "./Files.ts?vue&type=script&lang=ts&"
export * from "./Files.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports